'use client';

import * as React from 'react';
import { useFormContext } from 'react-hook-form';
import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form';
import { Input } from '@/components/ui/input';

interface FormInputProps {
  name: string;
  label: string;
  placeholder?: string;
  type?: 'text' | 'email' | 'password';
  maxLength?: number;
  hint?: string | React.ReactNode;
  optional?: boolean;
  autoComplete?: string;
  disabled?: boolean;
}

export function FormInput({
  name,
  label,
  placeholder,
  type = 'text',
  maxLength,
  hint,
  optional,
  autoComplete,
  disabled,
}: FormInputProps) {
  const form = useFormContext();

  return (
    <FormField
      control={form.control}
      name={name}
      render={({ field }) => (
        <FormItem>
          <FormLabel>
            {label}
            {optional && <span className="ml-1 text-muted-foreground">(optional)</span>}
          </FormLabel>
          <FormControl>
            <Input
              {...field}
              type={type}
              placeholder={placeholder}
              maxLength={maxLength}
              autoComplete={autoComplete}
              disabled={disabled}
            />
          </FormControl>
          {hint && <FormDescription>{hint}</FormDescription>}
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
